<script>

import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  components: {
  },
  props: ['projectsStatus'],
  name: 'ProjectByStatus',
  data () {
    return {
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      data: {
        datasets: [{
          data: [ 0, 0, 0 ],
          backgroundColor: ['rgba(52, 152, 219, 0.8)', 'rgba(213, 157, 16, 0.8)', 'rgba(98, 203, 49, 0.5)', 'rgba(64, 155, 29, 0.8)', 'rgba(30, 107, 10, 0.8)']
        }],
        labels: []
      }
    }
  },
  methods: {
    draw: function () {
      this.data.datasets[0].data = []
      let statusValues = []
      let statusLabels = []
      Object.keys(this.projectsStatus).forEach((element) => {
        statusLabels.push(element)
        statusValues.push(this.projectsStatus[element])
      })
      this.data.datasets[0].data = statusValues
      this.data.labels = statusLabels

      this.renderChart(this.data, this.options)
    }
  },
  mounted () {
    this.draw()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/ProjectByStatus.vue